<template>
    <div>
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-col cols="12" md="12">
                <v-card  width="100%">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Solicitud de Pago</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="5">
                                    <label>
                                        Establecer algún criterio de búsqueda:
                                    </label>
                                    <br />
                                    <vs-list>
                                        <v-col cols="12" md="5">
                                            <label class="typo__label" style="text-align: center;">Clasificación:</label>
                                            <v-radio-group column v-model="clasificacion" @change="changed" :rules="[v => !!v || 'Opción requerida']">
                                                <v-radio label="Diversos"
                                                         value="01"></v-radio>
                                                <v-radio label="Gestoría"
                                                         value="03"></v-radio>
                                                <v-radio label="Bonos"
                                                         value="05"></v-radio>
                                                <v-radio label="Garantía"
                                                         value="02"></v-radio>
                                                <v-radio label="Sentencia"
                                                         value="04"></v-radio>
                                                <v-radio label="Anticipo de honorarios"
                                                         value="06">Anticipo de honorarios</v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </vs-list>
                                    <vs-list>
                                        <label class="typo__label" style="text-align: center;">SubClasificación:</label>
                                        <div>
                                            <multiselect placeholder="Seleccione un valor"
                                                         :options="subclasificacion"
                                                         v-model="subclas"
                                                         label="gtnivel4" track-by="gtcv4" :allow-empty="false"
                                                         deselect-label="No se puede remover el valor seleccionado"
                                                         selected-label="Seleccionado" select-label="Seleccionar valor" @input="msConcepto()">
                                            </multiselect>
                                            <span style="color: red;" v-if="validasubclas">Selección requerida</span>
                                        </div>
                                    </vs-list>
                                    <vs-list>
                                        <label class="typo__label" style="text-align: center;">Concepto:</label>
                                        <div>
                                            <multiselect placeholder="Seleccione un valor"
                                                         :options="concepto"
                                                         v-model="concep" :allow-empty="false"
                                                         label="gtnivel5" track-by="gtcv5"
                                                         deselect-label="No se puede remover el valor seleccionado"
                                                         selected-label="Seleccionado" select-label="Seleccionar valor" @input="addconcepto()">
                                            </multiselect>
                                            <span style="color: red;" v-show="validaconcep">Selección requerida</span>
                                        </div>
                                    </vs-list>
                                </v-col>
                            <!--</v-row>
                            <v-row>-->
                                <v-col cols="12" md="7">
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <label class="typo__label" style="text-align: center;">Solicitud por concepto de:</label>
                                            <v-text-field outlined
                                                          dense
                                                          readonly
                                                          v-model="solicitudConcepto">
                                            </v-text-field>
                                            <label class="typo__label" style="text-align: center;">Monto:</label>
                                            <v-text-field outlined md="4"
                                                          dense
                                                          autocomplete="off"
                                                          prepend-inner-icon="mdi-currency-usd"
                                                          @input="Cantidad"
                                                          @keypress="filter($event)"
                                                          :rules="rulesmonto"
                                                          v-model="cantidad">
                                            </v-text-field>
                                            <v-text-field outlined
                                                          dense
                                                          readonly
                                                          v-model="cantidadtexto">
                                            </v-text-field>
                                            <label class="typo__label" style="text-align: center;">Depositar a:</label>
                                            <v-text-field outlined
                                                          dense
                                                          rows="2"
                                                          :rules="[v => !!v || 'Campo requerido']"
                                                          v-on:blur="depositar = depositar.trim()"
                                                          v-model="depositar">
                                            </v-text-field>
                                           
                                        </v-col>
                                        <v-col cols="12" md="6" class="mt-n4">
                                            <label class="typo__label" style="text-align: center;">Banco:</label>
                                            <v-text-field outlined
                                                          dense
                                                          :rules="[v => !!v || 'Campo requerido']"
                                                           v-on:blur="banco = banco.trim()"
                                                          v-model="banco">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6"  class="mt-n4">
                                            <label class="typo__label" style="text-align: center;">Cuenta:</label>
                                            <v-text-field outlined
                                                          dense
                                                          :rules="[v => !!v || 'Campo requerido']"
                                                           v-on:blur="cuenta = cuenta.trim()"
                                                          v-model="cuenta">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="12">
                                            <label class="typo__label" style="text-align: center;">Observaciones:</label>
                                            <v-textarea outlined
                                                        dense
                                                        :counter="500"
                                                        :rules="rulestextarea"
                                                        required
                                                           v-on:blur="observacion = observacion.trim()"
                                                        v-model="observacion">
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row justify="center" class="mb-8">
                            <v-btn @click="Guardar()" class="ma-2"
                                   color="primary">
                                Vista Previa
                                <template v-slot:loader>
                                    <span>Loading...</span>
                                </template>
                            </v-btn>
                            <v-btn @click="Limpiar()" class="ma-2" color="default">
                                Limpiar
                            </v-btn>
                            <v-btn color="error" @click="Regresar()" class="ma-2">
                                Regresar
                            </v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import TramitePago from '@/services/TramitePago/TramitePago.Service.js';
    import Asistencia from '@/services/AsistenciaGeneral/AsistenciaGeneral.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        data: function () {
            return {
                valid: true,
                showcargando: false,
                validasubclas: false,
                validaconcep: false,
                clasificacion: '',
                subclasificacion: [],
                concepto: [],
                subclas: '',
                concep: '',
                solicitudConcepto: '',
                cantidad: '',
                cantidadtexto: '',
                depositar: '',
                banco: '',
                cuenta: '',
                observacion: '',
                reporte: 0,
                indice: 0,
                rulestextarea: [
                    v => !!v || 'Campo requerido',
                    v => {
                        if (v == null) {
                            return true
                        }
                        else {
                            if (v.length <= 12) {
                                return 'Mínimo 12 Carácteres'
                            }
                            else if (v.length > 500) {
                                return 'Máximo 500 Carácteres'
                            }
                            else
                                return true
                        }
                    },
                ],
                datos: {},
                rulesmonto: [
                    v => !!v || 'Campo requerido',
                    v => {
                        if (v == null) {
                            return true
                        }
                        else {
                            if (v > 300000) {
                                return 'Debes de dar una cantidad valida maxima 300,000'
                            }
                            else if (v < 500) {
                                return 'Debes de dar una cantidad valida Mínimo 500'
                            }
                            else
                                return true
                        }
                    },
                ],
                asistenciaurl: '',
            }
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        watch: {
            'subclas': function () {
                if (this.subclas != '')
                    this.validasubclas = false;
                else
                    this.validasubclas = true;
            },
            'concep': function () {
                if (this.concep != '')
                    this.validaconcep = false;
                else
                    this.validaconcep = true;
            },
            'cantidad': function () {
                if (this.cantidad.length > 0)
                    this.cantidadtexto = MetodosGenerales.covertirNumerosALetras(this.cantidad, 'MXN');
            }
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),

            PagoDatosReporte() {
                let dato = new FormData();
                dato.append("nrreporte", this.reporte);
                dato.append("svindice", this.indice);
                TramitePago.PagoDatosReporte(this, dato).then(data => {
                    this.depositar = data[0].prnombre;
                    this.cuenta = data[0].prctaban;
                    this.banco = data[0].banombre;
                });
            },
            changed() {
                let n1 = '', n2 = '';
                this.subclas = '';
                this.concep = '';
                this.solicitudConcepto = '';
                if (this.clasificacion == '05') {
                    n1 = '06';
                    n2 = '01';
                }
                else if (this.clasificacion == '06') {
                    n1 = '06';
                    n2 = '03';
                }
                else {
                    n1 = '05';
                    n2 = this.clasificacion;
                }

                let formdata = new FormData();
                formdata.append("gtcv2", n1);
                formdata.append("gtcv3", n2);

                TramitePago.PagoSubConcepto(this, formdata).then(data => {
                    this.subclasificacion = data;
                }); 
            },
            msConcepto() {
                this.solicitudConcepto = '';
                this.concep = '';
                let n1 = '', n2 = '', n3 = '';
                
                if (this.clasificacion == '05') {
                    n1 = '06';
                    n2 = '01';
                }
                else if (this.clasificacion == '06') {
                    n1 = '06';
                    n2 = '03';
                }
                else {
                    n1 = '05';
                    n2 = this.clasificacion;
                }

                if (this.subclas != null) {
                    n3 = this.subclas.gtcv4;

                    let dato = new FormData();
                    dato.append("n2", n1);
                    dato.append("n3", n2);
                    dato.append("n4", n3);
                    TramitePago.SubConcepto(this, dato).then(data => {
                        this.concepto = data;
                    });
                }
                else {
                    this.validasubclas = true;
                    this.concep = '';
                }
            },
            addconcepto() {
                if(this.concep != null)
                    this.solicitudConcepto = this.concep.gtid + ' ' + this.subclas.gtnivel4 + ' - ' + this.concep.gtnivel5;
            },
            Cantidad() {
                if (this.cantidad != '')
                    this.cantidadtexto = MetodosGenerales.covertirNumerosALetras(this.cantidad, 'MXN');
            },
            async Guardar() {
                if (this.subclas == '' || this.subclas == null)
                    this.validasubclas = true;
                if (this.concep == '' || this.concep == null)
                    this.validaconcep = true;

                if (this.$refs.form.validate() && !this.validasubclas && !this.validaconcep) {
                    let data = [{
                        cantidad: this.cantidad,
                        cantidadtexto: this.cantidadtexto,
                        depositar: this.depositar,
                        banco: this.banco,
                        cuenta: this.cuenta,
                        observacion: this.observacion,
                        solicitudConcepto: this.solicitudConcepto
                    }];

                    //const finalResult = Object.assign(this.datos, data);
                    //await MetodosGenerales.guardarEnSesionInfoReporte(finalResult, 'reporte');

                    await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'param');
                    //await MetodosGenerales.guardarEnSesionInfoReporte(data, 'pago');

                    this.$router.push({ path: this.asistenciaurl + '/Garantias/FormatoSolicitud', query: { dato: data } });
                    //switch (this.datos.aiclave.toString()) {
                    //    case "1":
                    //        this.$router.push({ name: `FormatoSolicitudExpJur`, params: { dato: data } });
                    //        break;
                    //    case "24":
                    //        this.$router.push({ name: `FormatoSolicitudRobo`, params: { dato: data } });
                    //        break;
                    //    case "23":
                    //        this.$router.push({ name: `FormatoSolicitudRLV`, params: { dato: data } });
                    //        break;
                    //    case "5":
                    //        this.$router.push({ name: `FormatoSolicitudRCMedico`, params: { dato: data } });
                    //        break;
                    //}
                }
            },
            Regresar() {
                this.$router.push({ path: this.asistenciaurl + '/Garantias' });
                //switch (this.datos.aiclave.toString()) {
                //    case "1":
                //        this.$router.push({ name: `GarantiasExpJur` });
                //        break;
                //    case "24":
                //        this.$router.push({ name: `GarantiasRobo` });
                //        break;
                //    case "23":
                //        this.$router.push({ name: `GarantiasRLV` });
                //        break;
                //    case "5":
                //        this.$router.push({ name: `GarantiasRCMedico` });
                //        break;
                //}
            },
            Limpiar() {
                this.validasubclas = false;
                this.validaconcep = false;
                this.solicitudConcepto = '';
                this.cantidadtexto = '';
                this.subclas = '';
                this.concep = '';
                this.observacion = '';
                this.subclasificacion = [];
                this.concepto = [];
                this.clasificacion = '';
                this.cantidad = '';
            },
            filter: function (evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();

                if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
        },
        async mounted() {
            this.datos = await MetodosGenerales.obtenerSessionReporte('param');
            this.reporte = this.datos.nrreporte;
            this.indice = this.datos.svindice;
            this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            //let formData = new FormData();
            //formData.append("nrreporte", this.datos.nrreporte);
            //formData.append("svindice", this.datos.svindice);
            //await Asistencia.ObtenerUrl(formData).then(data => {
            //    console.log(data);
            //    if (data.success == true) {
            //        this.asistenciaurl = data.result;
            //    }
            //    else
            //        this.asistenciaurl = '';
            //});
            //this.changeReporteMenuOption(this.datos.urlname);
            this.changeReporteMenuOption("Garantías");
            this.PagoDatosReporte();

        },
    }
</script>